const Saturate = () => {
  return (
    <div className="absolute top-0 left-0 right-0 bottom-0 backdrop-saturate-0 back-color-2/30">
      <span className="invisible">DialogMakers</span>
    </div>
  );
};

export default Saturate;
